/**
 * ExceptionalFire Homepage — Animations & Interactions
 * Scroll reveals, stat countups, phone injection, header shadow
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Scroll Reveal ─────────────────────────────────────────────── */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    revealEls.forEach(function (el) {
      if (reducedMotion) { el.style.opacity = '1'; return; }
      var delay = (parseInt(el.dataset.delay, 10) || 0) * 120;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 500ms cubic-bezier(0.22,1,0.36,1) ' + delay + 'ms, transform 500ms cubic-bezier(0.22,1,0.36,1) ' + delay + 'ms';
    });
    var revealObs = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        obs.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { if (!reducedMotion) revealObs.observe(el); });
  }

  /* ── 2. Stat Count-Up ─────────────────────────────────────────────── */
  var countEls = document.querySelectorAll('[data-count]');
  if (countEls.length) {
    var countObs = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        var target = parseFloat(e.target.dataset.count);
        var suffix = e.target.dataset.suffix || '';
        var isDecimal = String(target).indexOf('.') !== -1;
        var decimals = isDecimal ? String(target).split('.')[1].length : 0;
        var start = performance.now();
        var duration = 1200;
        (function step(now) {
          var t = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - t, 3); // easeOut cubic
          var val = ease * target;
          e.target.textContent = (isDecimal ? val.toFixed(decimals) : Math.round(val)) + suffix;
          if (t < 1) requestAnimationFrame(step);
        })(start);
      });
    }, { threshold: 0.5 });
    countEls.forEach(function (el) { countObs.observe(el); });
  }

  /* ── 3. Phone Number Injection (anti-spam) ─────────────────────── */
  var _ph = '(949) 619-7824', _tel = 'tel:+19496197824', _ft = 'facetime:9496197824';
  document.querySelectorAll('[data-phone]').forEach(function (el) {
    if (el.tagName === 'A') {
      el.href = el.getAttribute('data-facetime') === 'true' ? _ft : _tel;
      if (!el.textContent.trim() || el.textContent.trim() === '...') el.textContent = _ph;
    } else {
      el.textContent = _ph;
    }
  });
  document.querySelectorAll('.ef-phone-text').forEach(function (el) {
    el.textContent = _ph;
  });

  /* ── 4. Header Shadow on Scroll ────────────────────────────────── */
  /* PERF FIX 2026-04-29: was using infinite requestAnimationFrame loop
     reading window.scrollY 60×/sec — Lighthouse audit showed this single
     loop consumed ~9.5s of main-thread time, causing TBT 1.2s+ and
     Style&Layout 5.6s. Replaced with passive scroll listener which only
     runs on actual scroll events. */
  var header = document.querySelector('.shopify-section--header') || document.querySelector('.hdr');
  if (header) {
    var hasShadow = false;
    var shadow = '0 2px 8px rgba(0,0,0,.08)';
    var lastY = 0;
    var rafScheduled = false;
    function applyShadow() {
      rafScheduled = false;
      var need = lastY > 10;
      if (need !== hasShadow) {
        header.style.boxShadow = need ? shadow : 'none';
        hasShadow = need;
      }
    }
    window.addEventListener('scroll', function () {
      lastY = window.scrollY;
      if (!rafScheduled) {
        rafScheduled = true;
        requestAnimationFrame(applyShadow);
      }
    }, { passive: true });
  }
})();
